import { FC, useState, useEffect } from "react";
import {
  Container,
  Box,
} from "@mui/material";
import { CircularProgressMolecule } from "../components/molecules/CircularProgressMolecule";
import { VisualizedMenus } from "../components/VisualizedMenus";
import { useAuth0Token } from "../common/http-requests";
import { commentHome } from "../common/Comment";
import { useTranslation } from 'react-i18next';
import CommentMessages from "../components/CommentMessages";
import { useCustomMediaQuery } from "../common/useCustomMediaQuery";
import { pageMt } from "../common/util";
import {
  useUserId,
  useUserNickname,
} from "../hooks/useStoreGetters";


const HomePage: FC = () => {
  const [isSending, setIsSending] = useState(true);
  const { getToken } = useAuth0Token();
  const userId = useUserId();
  const userNickname = useUserNickname();
  const [commentMessage, setCommentMessage] = useState<string>('');
  const { t } = useTranslation(); // i18next
  const { isDesktop } = useCustomMediaQuery();

  useEffect(() => {
    getPageData();
  }, []);

  const getPageData = async () => {
    setIsSending(true);
    try {
      setCommentMessage(await commentHome(userId, userNickname, await getToken(), t));
    } catch {
    } finally {
      setIsSending(false);
    }
  };

  return (
    <>
      <Container maxWidth="xl">
        {isSending ? (
          <>
            <CircularProgressMolecule displayLabel={t("msg.loading")} />
          </>
        ) : (
          <>
            <VisualizedMenus />
            <Box mt={pageMt(isDesktop)}>
              <CommentMessages message={commentMessage} />
            </Box>
          </>
        )}
      </Container >
    </>
  );
};

export default HomePage;
